import { CircleCheckIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

import { PASSWORD_FORM_CHECKLIST } from "./data";

export const PasswordInputChecklist = ({
  inputValue
}: {
  inputValue: string;
}) => (
  <div
    className="flex flex-col gap-1 justify-center mt-4"
    data-testid="password-input-checklist"
  >
    {PASSWORD_FORM_CHECKLIST.map(({ key, label, regex }) => {
      return (
        <div className="flex items-center gap-2" key={key}>
          <CircleCheckIcon
            aria-labelledby={`password-input-checklist-${key}`}
            className={twMerge(
              "w-4 h-4",
              regex.exec(inputValue) ? "fill-shamrock-green" : "fill-light-gray"
            )}
          />
          <p
            id={`password-input-checklist-${key}`}
            className="text-sm leading-[22px] text-txtHeading"
          >
            {label}
          </p>
        </div>
      );
    })}
  </div>
);
